import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import moment from 'moment'

const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

export class RecursoshumanosDictamenIncidenciasComponent {
  idEmpresa
  periodo
  clasePrimaDeRiesgoId
  registroPatronalId
  promise = null
  operadoras = []
  clasesPrimasDeRiesgos = []
  registrosPatronales = []
  periodos = []
  data = []

  constructor (RecursoshumanosDictamenIncidencias, RecursoshumanosOperadorasService, RecursosHumanosClasePrimaDeRiesgo, RecursosHumanosClasePrimaDeRiesgoRegistroPatronales, $location, $q) {
    this.RecursoshumanosDictamenIncidencias = RecursoshumanosDictamenIncidencias
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursosHumanosClasePrimaDeRiesgo = RecursosHumanosClasePrimaDeRiesgo
    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales = RecursosHumanosClasePrimaDeRiesgoRegistroPatronales
    this.$location = $location
    this.$q = $q
  }

  $onInit () {
    this.promise = this.$q.all([
      this.RecursoshumanosOperadorasService.get()
        .then(({data}) => (this.operadoras = orderBy(data, ['nombre']))),
      this.RecursosHumanosClasePrimaDeRiesgo.get()
        .then(({data}) => (this.clasesPrimasDeRiesgos = data)),
    ])

    if (this.idEmpresa && this.clasePrimaDeRiesgoId) {
      if (this.periodo && this.registroPatronalId) {
        this.buscar()
      }

      this.buscarRegistrosPatronales()
    }
  }

  buscarRegistrosPatronales () {
    if (!this.idEmpresa || !this.clasePrimaDeRiesgoId) return

    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales.get(this.idEmpresa, this.clasePrimaDeRiesgoId)
      .then(({data}) => (this.registrosPatronales = data))
      .then(() => (this.validarRegistroPatronal()))
  }

  validarRegistroPatronal () {
    if (!this.registrosPatronales.length) return
    if (this.registroPatronalId && (!this.registrosPatronales.map(i => i.id).includes(this.registroPatronalId))) {
      this.registroPatronalId = undefined
    }
  }

  buscar () {
    if (!this.idEmpresa || !this.clasePrimaDeRiesgoId || !+this.periodo || !this.registroPatronalId) return

    this.$location.search({
      id_empresa: this.idEmpresa,
      periodo: this.periodo,
      clasePrimaDeRiesgoId: this.clasePrimaDeRiesgoId,
      registroPatronalId: this.registroPatronalId,
    })

    this.data = []
    this.buscando = true
    let excel = 0

    this.RecursoshumanosDictamenIncidencias.get(this.idEmpresa, this.periodo, this.clasePrimaDeRiesgoId, excel, this.registroPatronalId)
      .then(({data}) => {
        this.data = orderBy(data, ['mes', 'nombre'])
        this.data.forEach(item => {
          item.mes_descripcion = meses[item.mes - 1]
          item.fecha_movimiento = moment(item.fecha_movimiento).format('LL')
        })
      })
      .finally(() => (this.buscando = false))
  }
}

module.component('recursoshumanosDictamenIncidencias', {
  controller: RecursoshumanosDictamenIncidenciasComponent,
  template,
  bindings: {
    idEmpresa: '<',
    periodo: '<',
    clasePrimaDeRiesgoId: '<',
    registroPatronalId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/dictamen/incidencias/component.js